export default {
  'option.name.currency': 'Currency',
  'option.name.currencyName': 'Currency Name',
  'option.on': 'On',
  'option.off': 'Off',
  'option.yes': 'Yes',
  'option.name.time': 'Time',
  'option.yesterday': 'Yesterday',
  'option.today': 'Today',
  'option.lastWeek': 'Last week',
  'option.thisWeek': 'This week',
  'option.lastMonth': 'Last month',
  'option.thisMonth': 'This month',
  // 'option.startTime.placeholder': 'Please select a start time',
  // 'option.endTime.placeholder': 'Please select a end time',
  'option.lowest': 'Lowest',
  'option.highest': 'Highest',
  'option.noRefresh': 'Do not Refresh',
  'option.seconds': 'Seconds',
  'option.enable': 'Enable',
  'option.maintenance': 'Maintenance',
  'option.pushType': 'Push type',
  'option.sendNow': 'Send now',
  'option.sendRegularly': 'Send regularly',
  'option.whetherToEnable': 'Whether to enable',
  'option.turnOn': 'Turn on',
  'option.closure': 'Closure',
  'option.show': 'Show',
  'option.dontShow': "Don't show",
  'option.selectAll': 'Select all',
  'option.checkLeastOne': 'Check at least one option',
  'option.displayTerminal': 'Display terminal',
  'option.deactivate': 'Deactivate',
  'option.open': 'Open',
  'option.maintenanceSwitch': 'Maintenance switch',
  'option.applicableLevel': 'Applicable level',
  'option.webHall': 'Web Hall',
  'option.welcomePage': 'Welcome Page',
  'option.webAppDownloadSite': 'Web-APP Download Site',
  'option.channelLink': 'Channel Link',
  'option.beijingTime': 'Beijing time',
  'option.easternTime': 'Eastern Time',
  'option.reviewDate': 'Review date',
  'option.paid': 'Paid',
  'option.notPaid': 'Not paid',
  'option.underReview': 'Under review',
  'option.rechargeRatio': 'Recharge ratio',
  'option.withdrawalRatio': 'Withdrawal ratio',
  'option.registrationProportion': 'Registration proportion',
  'option.loginRatio': 'Login ratio',
  'option.loginRetention': 'Login Member Retention',
  'option.activeRetention': 'Active member retention',
  'option.rechargeRate': 'Recharge conversion rate',
  'option.withdrawalConversionRate': 'Withdrawal conversion rate',
  'option.bettingRate': 'Betting conversion rate',
  'option.transferOut': 'Transfer out',
  'option.interest': 'Interest',
  'option.applyRejection': 'You can apply after rejection',
  'option.longRejectionAgain': 'How long after rejection can I apply again',
  'option.alipayCode': 'Alipay payment code',
  'option.weChatCode': 'WeChat payment code',
  'option.cloudPaymentCode': 'Cloud QuickPass payment code',
};
